export default __webpack_public_path__ + "static/media/Grub-MobileWeb.682366b3.jpg";